import { render } from "./RefundDetail.vue?vue&type=template&id=8cff58a4&scoped=true"
import script from "./RefundDetail.vue?vue&type=script&lang=js"
export * from "./RefundDetail.vue?vue&type=script&lang=js"

import "./RefundDetail.vue?vue&type=style&index=0&id=8cff58a4&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cff58a4"]])

export default __exports__